import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CandidateHomeComponent } from './home/candidate-home/candidate-home.component';
import { EmployerHomeComponent } from './home/employer-home/employer-home.component';
import { CandidateComponent } from './candidate/candidate.component';
import { EmployerComponent } from './employer/employer.component';
import { SignInComponent } from './auth/sign-in/sign-in.component';
import { EmployerSignUpComponent } from './auth/sign-up/employer-sign-up/employer-sign-up.component';
import { CandidateSignUpComponent } from './auth/sign-up/candidate-sign-up/candidate-sign-up.component';
import { AngularFireAuthGuard, redirectUnauthorizedTo, redirectLoggedInTo, canActivate } from '@angular/fire/auth-guard';
import { CreateProfileComponent } from './candidate/create-profile/create-profile.component';
import { HelpComponent } from './common/help/help.component';
import { DashboardComponent } from './candidate/dashboard/dashboard.component';
import { OverviewComponent } from './candidate/dashboard/overview/overview.component';
import { EditProfileComponent } from './candidate/dashboard/edit-profile/edit-profile.component';
import { AccountComponent } from './candidate/dashboard/account/account.component';
import { CreateEmployerProfileComponent } from './employer/create-employer-profile/create-employer-profile.component';
import { EmployerDashboardComponent } from './employer/employer-dashboard/employer-dashboard.component';
import { EmployerOverviewComponent } from './employer/employer-dashboard/employer-overview/employer-overview.component';
import { PostJobComponent } from './employer/employer-dashboard/post-job/post-job.component';
import { ViewJobComponent } from './employer/employer-dashboard/view-job/view-job.component';
import { DetailedViewComponent } from './employer/employer-dashboard/view-job/detailed-view/detailed-view.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { EmployerEditProfileComponent } from './employer/employer-dashboard/employer-edit-profile/employer-edit-profile.component';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['sign-in']);
const redirectLoggedInToDashboard = () => redirectLoggedInTo(['dashboard']);

const routes: Routes = [
  {
    path: '',
    component: CandidateHomeComponent,
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectLoggedInToDashboard }
  },
  {
    path: 'employers',
    component: EmployerHomeComponent
  },
  {
    path: 'help',
    component: HelpComponent
  },
  {
    path: 'dashboard',
    component: CandidateComponent,
    children: [
      {
        path: '', component: DashboardComponent,
        children: [
          {
            path: 'overview', component: OverviewComponent
          },
          {
            path: 'edit-profile', component: EditProfileComponent
          },
          {
            path: 'account', component: AccountComponent
          },
          {
            path: '', redirectTo: 'overview', pathMatch: 'full'
          }
        ]
      }
    ],
    // canActivate: [AngularFireAuthGuard],
    // data: { authGuardPipe: redirectUnauthorizedToLogin }
  },
  {
    path: 'create-profile',
    component: CreateProfileComponent,
    // canActivate: [AngularFireAuthGuard],
    // data: { authGuardPipe: redirectUnauthorizedToLogin }
  },
  {
    path: 'employer-create-profile',
    component: CreateEmployerProfileComponent,
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin }
  },
  {
    path: 'employer-dashboard',
    component: EmployerComponent,
    children: [
      {
        path: '', component: EmployerDashboardComponent,
        children: [
          {
            path: 'overview', component: EmployerOverviewComponent
          },
          {
            path: 'post-job', component: PostJobComponent
          },
          {
            path: 'view-job', component: ViewJobComponent
          },
          {
            path: 'edit-profile', component:EmployerEditProfileComponent
          },
          {
            path: '', redirectTo: 'overview', pathMatch: 'full'
          }
        ]
      }
    ],
    // canActivate: [AngularFireAuthGuard],
    // data: { authGuardPipe: redirectUnauthorizedToLogin }
  },
  {
    path: 'sign-in',
    component: SignInComponent,
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectLoggedInToDashboard }
  },
  {
    path: 'sign-up',
    component: CandidateSignUpComponent,
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectLoggedInToDashboard }
  },
  {
    path: 'employer-sign-up',
    component: EmployerSignUpComponent
  },
  { path: 'detailed', redirectTo: 'detailed/', pathMatch: 'full' },
  { path: 'detailed/:id', component: DetailedViewComponent },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
